import React from 'react';
import LandingPageComponent from '../components/LandingPage/LandingPageComponent';

const LandingPageContainer: React.FC = () => {
  return (<LandingPageComponent />);
}

export default LandingPageContainer;